import { API_URL, apiRequest } from './api';

const API_CUSTOMER_URL = `${API_URL}/customer`;

// Customers API Methods
export const fetchAllCustomers = async () => {
  return apiRequest('GET', API_CUSTOMER_URL);
};

export const fetchCustomerById = async (id: number) => {
  return apiRequest('GET', `${API_CUSTOMER_URL}/${id}`);
};

export const saveOrUpdateCustomer = async (customer: {
  id: number;
  name: string;
}) => {
  return apiRequest('POST', API_CUSTOMER_URL, customer);
};

export const deleteCustomer = async (id: number) => {
  return apiRequest('DELETE', `${API_CUSTOMER_URL}/${id}`);
};
